import {createTextVariant} from './Text.js'

export default createTextVariant('h4', 'H4')
